import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { VatReportSubmissionStep } from '@app/services/vat-report.service';

@Component({
    selector: 'tt-vat-report-submission-steps',
    templateUrl: './vat-report-submission-steps.component.html',
    styleUrls: ['./vat-report-submission-steps.component.css'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VatReportSubmissionStepsComponent {
    @Input()
    public steps: VatReportSubmissionStep[] = [];

    @Input()
    public stepNo = '0';

    public get activeStep(): VatReportSubmissionStep | undefined {
        return this.steps.find((step) => step.step_no === this.stepNo);
    }

    @HostBinding('hidden')
    public get hidden(): boolean {
        return this.stepNo === '0' || !this.activeStep;
    }

    public getStepIcon(step: VatReportSubmissionStep): string {
        const isLastStep = step === this.steps[this.steps.length - 1];
        const isCurrentStep = step.step_no === this.stepNo;

        if (+step.step_no < +this.stepNo || (isLastStep && isCurrentStep)) return 'fa-check-circle step-finished';

        return isCurrentStep ? '' : 'fa-circle step-pending';
    }
}
